import {
  GlobalOutlined,
  CalendarOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import styled from 'styled-components';

const getTag = ({ type, t }) => {
  switch (type) {
    case 'document':
      return (
        <Tag icon={<PaperClipOutlined />}>{t('Document')}</Tag>
      );
    case 'weblink':
      return (
        <Tag icon={<GlobalOutlined />}>{t('Weblink')}</Tag>
      );
    default:
      return null;
  }
};

const Style = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .cont {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.main-cont {
      flex: 1;
    }
  }

  .item {
    padding: 8px 0;
    border-bottom: 1px solid #F4F4F4;

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      padding-bottom: 0;
    }

    &:last-of-type {
      border-bottom: 0px;
    }

    .name {
      label {
        font-size: 10px;
        word-break: break-all;
        color: var(--base-gray-70);
        margin-bottom: 0px;
      }
    }

    .date {
      display: flex;
      gap: 6px;
      margin-bottom: 4px;

      svg {
        color: var(--color-primary-70);
        width: 10px;
        height: 10px;
      }

      label {
        margin-bottom: 0px;
        color: var(--base-gray-50);
        font-weight: 500;
        font-size: 10px;

        &.reporter {
          color: var(--base-gray-50);
        }
      }
    }

    .header {
      display: flex;

      h5 {
        margin-bottom: 0px;
        color: var(--base-gray-90);
        font-size: 14px;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .cont {
        .ant-tag {
          margin-right: 0px;
          color: var(--base-gray-70);
          width: 92px;
          text-align: center;

          svg {
            margin-top: -4px;
          }
        }
      }
    }
  }
`;

const DocumentsList = ({
  data = [],
  t = (s) => s,
  isSingleSource = false,
}) => {
  return (
    <Style>
      {data.map((d, i) => (
        <div className="item" key={`documents-${i + 1}`}>
          <div className="header">
            <div className="cont main-cont">
              <h5>{d.title}</h5>
            </div>
            <div className="cont">
              {getTag({ type: d.type, t })}
            </div>
          </div>
          <div className="date">
            {(!isSingleSource && typeof d.reporter === 'string') && (
              <div className="cont">
                <label className="reporter">{t('By')} {d.reporter}</label>
              </div>
            )}
            <div className="cont">
              <CalendarOutlined />
            </div>
            <div className="cont">
              <label>{moment(d.date).format('DD MMM YYYY')}</label>
            </div>
          </div>
          <div className="name">
            <label>{d.name}</label>
          </div>
        </div>
      ))}
    </Style>
  );
};

export default DocumentsList;
